import { Company } from "../../enums/Company";

export class ReportCreationRequest {
    public Type!: number;
    public Company!: Company;
    public StartDate!: Date;
    public EndDate!: Date;
}
